import React, { FunctionComponent } from 'react';
import {
  Grid,
  Typography,
} from '@mui/material';
import CalculationsComponent from './CalculationsComponent/CalculationsComponent'
import useStyles from './CalculationsDashboard.styles';

const CalculationsDashboard: FunctionComponent = () => {
  const classes = useStyles();
  const testid = 'admin-reports-dashboard';
  return (
    <Grid container spacing={4}>
      <Grid size={{ xs:12}}>
        <Typography
          variant="h1"
          className={classes.title }
          data-testid={`${testid}__title`}
        >
          HealthySteps ROI Calculations
        </Typography>
      </Grid>
      <Grid size={{ xs:12}}>
        <CalculationsComponent />
      </Grid>
    </Grid>
  );
};

export default CalculationsDashboard;